module.exports = __webpack_public_path__ + "img/video.2a91d8b9.png";